interface LogoProps {
  /** Rendered width in pixels. */
  width?: number;
  className?: string;
}

/** Gral Medical brand mark (served from /public/brand). */
export function Logo({ width = 180, className }: LogoProps) {
  return (
    <img
      src="/brand/gral-logo.svg"
      alt="Gral Medical"
      width={width}
      className={className}
      decoding="async"
    />
  );
}
